import { createSelector } from '@ngrx/store';
import { AppChooserDialogState } from './app-chooser-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den App-Chooser-Dialog.
 */
export class AppChooserDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): AppChooserDialogState => state.appChooserDialog,
  );

  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

  public static readonly intentConfig = createSelector(
    this._slice,
    (state) => state.intentConfig,
  );

  public static readonly appConfigs = createSelector(
    this._slice,
    (state) => state.appConfigs,
  );
}
